import * as Moment from "moment";
import { HttpResult } from "widgets-for-react";
import { TeaserProps } from "../teaser";

interface SearchResponse {
  Count: number
  Results: SearchablePage[]
}

interface SearchablePage {
  EntityType: string
  EntityId: number
  Title: string
  Content: string
  ImageUrls: { [key: string]: string };
  ImageAlt: string
  Url: string
  Description: string
  Bundle: string
  Keywords: string
  PublicationDate: string
}

const toTeaserProps = (p: SearchablePage): TeaserProps => ({
  headingLevel: 'h2',
  title: p.Title,
  intro: p.Description,
  label: Moment(p.PublicationDate).format('LL'),
  imageAlt: p.ImageAlt,
  imageUrl: p.ImageUrls['400x280'],
  imageUrlLarge: p.ImageUrls['800x560'],
  linkUrl: p.Url,
  key: `news_item_${p.EntityId}`
})

export const fetchRecentNews =
  (count: number) => async (): Promise<HttpResult<TeaserProps[]>> => {
    let headers = new Headers()
    headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

    const response = await fetch(`/api/v1/search/list?type=news&page=0&pageSize=${count}`, { headers })

    if (response.ok) {
      const body = (await response.json()) as SearchResponse
      return {
        kind: "result",
        value: body.Results.map(toTeaserProps),
        status: response.status
      }
    }

    return { kind: "failed", status: response.status }
  }